export default "__VITE_ASSET__BvLuJKjY__"